import { render } from "./FormularioRegistrarse.vue?vue&type=template&id=013e03c6&scoped=true"
import script from "./FormularioRegistrarse.vue?vue&type=script&lang=js"
export * from "./FormularioRegistrarse.vue?vue&type=script&lang=js"

import "./FormularioRegistrarse.vue?vue&type=style&index=0&id=013e03c6&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013e03c6"]])

export default __exports__